
export default {
  isEditMode: true,
  pageProperties: {
    testing: true,
    "pages": [
      { // ::PAGE Home
        "pageName": "home",
        "pageId": 101,
        "sections": [
          { // heading
            "sectionId": "jlqt54",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "fields": [
              { // Refresh token
                "fieldType": "refresh-token",
                "fieldId": "ij3432"
              },
              { // Heading, timer, subheading
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 10,
                    "alignItems": "center",
                    "textAlign": "center",
                    "justifyContent": "center",
                    marginTop: "50px",
                    marginBottom: "50px"
                  },
                  "fields": [
                    {
                      fieldType: "video-comp",
                      fieldId: "key123",
                      properties: {
                        grid: {
                          columns: 12,
                          marginBottom: "50px"
                        },
                        videoUrl: "https://jolt-assets.s3.eu-central-1.amazonaws.com/template/redbull/wingsforlife/new-video-home.mp4",
                        width: "700px",
                        mobileWidth: "100%",
                        styles: {
                          "border-radius": "39.0938px"
                        }
                      }
                    },
                    { // Timer
                      "fieldType": "empty-bucket",
                      "fieldId": "emp123154",
                      "properties": {
                        "grid": {
                          columns: 12,
                          justifyContent: "center",
                          alignItems: "center",
                          marginBottom: "60px"
                        },
                        fields: [
                          { // Timer
                            "fieldType": "countdown-timer",
                            "fieldId": "con1231",
                            "properties": {
                              "grid": {
                                "columns": 6
                              },
                              // This is GMT/UTC time
                              deadline: '08 May 2023 11:00:00 GMT',
                              image: {
                                src: '/assets/images/wfl.svg',
                                alt: 'World For Run',
                                maxWidth: '250px',
                                maxMobWidth: '130px'
                              },
                              styles: {
                                'flex-direction': 'row',
                                'flex-wrap': 'nowrap'
                              }
                            }
                          }
                        ]
                      }
                    },
                    { // Heading
                      "fieldType": "paragraph",
                      "fieldId": "234234234",
                      "properties": {
                        "grid": {
                          "columns": 12,
                          marginTop: "40px",
                          marginBottom: "50px"
                        },
                        text: "Welcome to the Wings for Life World Run 2023, and to your team GO TPV Cares!",
                        "className": "heading heading-emp text-center"
                      }
                    },
                    { // Text
                      "fieldType": "paragraph",
                      "fieldId": "fckzg78",
                      "properties": {
                        "text": `Once again we have the pleasure to invite all TPV employees (this includes our friends at AOC, MMD and PPDS) & Partners to run for those who can’t at the Wings for Life World Run on May 7th 2023. There are many reasons why we think it is worth participating, but mainly because:
                        <br>
                        <br>
                        <ul>
                          <li>
                            We will create enthusiasm for the GO range of Philips Sports Headphones
                          </li>
                          <li>
                            We want to support a cause we feel strong about: spinal cord injury research
                          </li>
                          <li>
                            We will grow the number of participants (and therefore, more funds will be raised)
                          </li>
                          <li>
                            We can engage all TPV employees & Partners in a fun activity and unite as one <b>GO TPV Cares! team</b>
                          </li>
                          <br>
                        </ul>
                        <br>
                        Download the app ‘’Wings for Life World Run’’ on your phone. You can take part in the Wings for Life World Run wherever you are. Everyone, worldwide, starts at the same time, running, walking and rolling to stay ahead of the Virtual Catcher Car. Download the App to inform, entertain and motivate you on the big day.
                        <br>
                        <br>
                        <b>SIGN UP NOW TO RECEIVE YOUR FREE VOUCHER</b>`,
                        "className": "text-left",
                        "grid": {
                          "columns": 12,
                          "marginTop": "20px"
                        },
                        styles: {
                          "font-size": "16px",
                          "line-height": "24px",
                          "color": "var(--text-color-2)"
                        }
                      }
                    },
                    { // Cards
                      fieldType: "empty-bucket",
                      filedId: "emp523",
                      properties: {
                        grid: {
                          columns: 12,
                          justifyContent: "center",
                          flexDirection: "row",
                          flexWrap: "wrap",
                          columnGap: "10px",
                          rowGap: "30px",
                          marginBottom: "50px"
                        },
                        fields: [
                          { // Card
                            fieldType: "card",
                            fieldId: "car123",
                            properties: {
                              grid: {
                                columns: 6,
                                paddingBottom: "20px"
                              },
                              styles: {
                                'flex-grow': "1"
                              },
                              image: {
                                src: "/assets/images/employee-2.jpg",
                                alt: "Employee register"
                              },
                              text: {
                                title: 'I AM A TP VISION EMPLOYEE'
                              },
                              button: {
                                text: 'Register',
                                action: {
                                  "fn": "goToPage",
                                  "params": "employee-page"
                                },
                                class: "btn-next",
                                styles: {
                                  "max-width": "200px;"
                                }
                              }
                            }
                          },
                          { // Card
                            fieldType: "card",
                            fieldId: "car113",
                            properties: {
                              grid: {
                                columns: 6,
                                paddingBottom: "20px"
                              },
                              styles: {
                                flex: "1"
                              },
                              image: {
                                src: "/assets/images/partner-2.jpg",
                                alt: "Partner register"
                              },
                              text: {
                                title: 'I AM A TP VISION PARTNER'
                              },
                              button: {
                                text: 'Register',
                                action: {
                                  "fn": "goToPage",
                                  "params": "partner-page"
                                },
                                class: "btn-back",
                                styles: {
                                  "max-width": "200px;"
                                }
                              }
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              }
            ]
          }
        ]
      },
      { // ::PAGE Employee
        "pageName": "employee-page",
        isPublic: true,
        "pageId": 105,
        "sections": [
          { // Heading
            "sectionId": "p43ogfp23",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "fields": [
              { // Refresh token
                "fieldType": "refresh-token",
                "fieldId": "ij3432"
              },
              {
                "fieldId": "6g23fh65",
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 12,
                    "alignItems": "center",
                    "justifyContent": "space-between",
                    "marginTop": "50px",
                    padding: "0"
                  },
                  styles: {
                    background: "#FFFFFF",
                    "box-shadow": "0px 15px 15px rgba(0, 0, 0, 0.07)",
                    "border-radius": "30px"
                  },
                  "fields": [
                    { // Image
                      "fieldType": "square-image",
                      "fieldId": "fckzg75",
                      "properties": {
                        "grid": {
                          "columns": 6
                        },
                        imageSource: "/assets/images/employee-2.jpg",
                        classes: 'top-image',
                        styles: {
                          padding: "0"
                        }
                      }
                    },
                    { // Timer
                      "fieldType": "empty-bucket",
                      "fieldId": "emp123154",
                      "properties": {
                        "grid": {
                          columns: 6,
                          justifyContent: "center",
                          alignItems: "center"
                        },
                        fields: [
                          { // Timer
                            "fieldType": "countdown-timer",
                            "fieldId": "con1231",
                            "properties": {
                              "grid": {
                                "columns": 10,
                                marginTop: "44px",
                                marginBottom: "44px"
                              },
                              // This is GMT/UTC time
                              deadline: '08 May 2023 11:00:00 GMT',
                              image: {
                                src: '/assets/images/wfl.svg',
                                alt: 'World For Run',
                                maxWidth: '250px',
                                maxMobWidth: '130px'
                              },
                              styles: {
                                "flex-direction": "column",
                                "flex-wrap": "nowrap",
                                "row-gap": "20px"
                              }
                            }
                          }
                        ]
                      }
                    },
                  ]
                }
              },
              {
                "fieldId": "6g23fh65",
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 8,
                    "alignItems": "center",
                    "justifyContent": "center",
                    "marginTop": "50px",
                    paddingLeft: "0"
                  },
                  "fields": [
                    { // Heading
                      "fieldType": "paragraph",
                      "fieldId": "234234234",
                      "properties": {
                        "grid": {
                          "columns": 12,
                          marginTop: "40px",
                          marginBottom: "50px"
                        },
                        text: "Welcome to the TP Vision Employee run registration page",
                        "className": "heading heading-emp text-center"
                      }
                    },
                    { // Subheading
                      "fieldType": "paragraph",
                      "fieldId": "34fs667wef",
                      "properties": {
                        "text": `<b>SIGN UP NOW TO RECEIVE YOUR FREE VOUCHER AND JOIN OUR TEAM!</b>
                        <br>
                        <br>
                        After signing up, please make sure you download the Wings for Life World Run Application on your phone and join our team: GO TPV Cares! Your captain, Stefan van Sabben, will be there to guide you on this journey.
                        <br>
                        <br>
                        <b>IMPORTANT NOTES:</b>
                        <ul>
                          <li>
                            Those vouchers are “single-use App Run Vouchers” – you can redeemed each voucher only once,
                          </li>
                          <li>
                            On May 7th at 10.00 am UTC registration for Wings for Life World Run App Running including redeeming the voucher will be closed,
                          </li>
                          <li>
                            Vouchers are valid for all countries worldwide,
                          </li>
                          <li>
                            Participants need to use the voucher code during the registration progress on the step “payment methods” either in the Wings for Life World Run App or on <a style="color: inherit; text-decoration: underline;" href="http://www.wingsforlifeworldrun.com/" target="_blank">http://www.wingsforlifeworldrun.com/</a>
                          </li>
                        </ul>`,
                        "grid": {
                          "columns": 12
                        },
                        "className": "subHeading text-left"
                      }
                    },
                    { // Text

                    }
                  ]
                }
              }
            ]
          },
          { // Form
            "sectionId": "3ofdv0gg",
            "grid": {
              "columns": "12",
              "justifyContent": "center"
            },
            "fields": [
              {
                "fieldId": "v023wn7er",
                "fieldType": "new-form",
                "properties": {
                  "grid": {
                    "columns": 6,
                    marginBottom: "50px"
                  },
                  "styles": {
                    "justifyContent": "center",
                    "alignItems": "center",
                    "flexDirection": "column",
                    "marginLeft": "0",
                    "marginRight": "0"
                  },
                  "successAction": {
                    "fn": "goToPage",
                    "params": "thank-you"
                  },
                  userType: 'employee',
                  "apiUrl": "https://js-backend.justsnap.eu/api/registerLastStep"
                }
              }
            ]
          }
        ]
      },
      { // ::PAGE Partner page
        "pageName": "partner-page",
        isPublic: true,
        "pageId": 106,
        "sections": [
          { // Heading
            "sectionId": "p43ogfp23",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "fields": [
              { // Refresh token
                "fieldType": "refresh-token",
                "fieldId": "ij3432"
              },
              {
                "fieldId": "6g23fh65",
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 12,
                    "alignItems": "center",
                    "justifyContent": "space-between",
                    "marginTop": "50px",
                    padding: "0"
                  },
                  styles: {
                    background: "#FFFFFF",
                    "box-shadow": "0px 15px 15px rgba(0, 0, 0, 0.07)",
                    "border-radius": "30px"
                  },
                  "fields": [
                    { // Image
                      "fieldType": "square-image",
                      "fieldId": "fckzg75",
                      "properties": {
                        "grid": {
                          "columns": 6
                        },
                        imageSource: "/assets/images/partner-2.jpg",
                        classes: 'top-image',
                        styles: {
                          padding: "0"
                        }
                      }
                    },
                    { // Timer
                      "fieldType": "empty-bucket",
                      "fieldId": "emp123154",
                      "properties": {
                        "grid": {
                          columns: 6,
                          justifyContent: "center",
                          alignItems: "center"
                        },
                        fields: [
                          { // Timer
                            "fieldType": "countdown-timer",
                            "fieldId": "con1231",
                            "properties": {
                              "grid": {
                                "columns": 10,
                                marginTop: "44px",
                                marginBottom: "44px"
                              },
                              // This is GMT/UTC time
                              deadline: '08 May 2023 11:00:00 GMT',
                              image: {
                                src: '/assets/images/wfl.svg',
                                alt: 'World For Run',
                                maxWidth: '250px',
                                maxMobWidth: '130px'
                              },
                              styles: {
                                "flex-direction": "column",
                                "flex-wrap": "nowrap",
                                "row-gap": "20px"
                              }
                            }
                          }
                        ]
                      }
                    },
                  ]
                }
              },
              {
                "fieldId": "6g23fh65",
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 8,
                    "alignItems": "center",
                    "justifyContent": "center",
                    "marginTop": "50px",
                    paddingLeft: "0"
                  },
                  "fields": [
                    { // Heading
                      "fieldType": "paragraph",
                      "fieldId": "fckzg75",
                      "properties": {
                        "grid": {
                          "columns": 12,
                          marginTop: "40px",
                          marginBottom: "50px"
                        },
                        text: "Welcome to the TP Vision Partner page",
                        "className": "heading heading-par text-center"
                      }
                    },
                    { // Subheading
                      "fieldType": "paragraph",
                      "fieldId": "34fs667wef",
                      "properties": {
                        "text": `<b>SIGN UP NOW TO RECEIVE YOUR FREE VOUCHER AND JOIN OUR TEAM!</b>
                        <br>
                        <br>
                        After signing up, please make sure you download the Wings for Life World Run Application on your phone and join our team: GO TPV Cares! Your captain, Stefan van Sabben, will be there to guide you on this journey.
                        `,
                        "grid": {
                          "columns": 12
                        },
                        "className": "subHeading text-left"
                      }
                    },
                    { // Subheading
                      "fieldType": "paragraph",
                      "fieldId": "34fs667wef",
                      "properties": {
                        "text": `<b>IMPORTANT NOTES:</b>
                        <br>
                        <br>
                        Those vouchers are “single-use App Run Vouchers” – you can redeem each voucher only once.
                        </br>
                        <br/>
                        On May 7th at 10.00 am UTC registration for Wings for Life World Run App, including redeeming the voucher will be closed.
                        <br/>
                        <br/>
                        Vouchers are valid for all countries worldwide.
                        <br/>
                        <br/>
                        Participants need to use the voucher code during the registration progress on the step “payment methods” either in the Wings for Life World Run App or on 
                        <a href="http://www.wingsforlifeworldrun.com/" target="_blank"><u>http://www.wingsforlifeworldrun.com/</u></a>
                        `,
                        "grid": {
                          "columns": 12
                        },
                        "className": "subHeading text-left"
                      }
                    }
                  ]
                }
              }
            ]
          },
          { // Form
            "sectionId": "3ofdv0gg",
            "grid": {
              "columns": "12",
              "justifyContent": "center"
            },
            "fields": [
              {
                "fieldId": "v023wn7er",
                "fieldType": "new-form",
                "properties": {
                  "grid": {
                    "columns": 6,
                    marginBottom: "50px"
                  },
                  "styles": {
                    "justifyContent": "center",
                    "alignItems": "center",
                    "flexDirection": "column",
                    "marginLeft": "0",
                    "marginRight": "0"
                  },
                  "successAction": {
                    "fn": "goToPage",
                    "params": "thank-you"
                  },
                  userType: 'partner',
                  "apiUrl": "https://js-backend.justsnap.eu/api/registerLastStep"
                }
              }
            ]
          }
        ]
      },
      { // ::PAGE Thank you
        "pageName": "thank-you",
        "pageId": 1111,
        "sections": [
          { // Heading
            "sectionId": "p43ogfp23",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "fields": [
              {
                "fieldId": "6g23fh65",
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 12,
                    "alignItems": "center",
                    "justifyContent": "center",
                    "marginTop": "50px",
                    padding: "90px",
                    columnGap: "130px",
                    rowGap: "45px"
                  },
                  styles: {
                    background: "#FFFFFF",
                    "box-shadow": "0px 15px 15px rgba(0, 0, 0, 0.07)",
                    "border-radius": "30px"
                  },
                  "fields": [
                    { // Image
                      "fieldType": "square-image",
                      "fieldId": "fckzg75",
                      "properties": {
                        "grid": {
                          "columns": 4
                        },
                        imageSource: "/assets/images/tpvision.png",
                        styles: {
                          padding: "0",
                          "max-width": "300px"
                        }
                      }
                    },
                    { // &
                      "fieldType": "square-image",
                      "fieldId": "fckzg75",
                      "properties": {
                        "grid": {
                          "columns": 4
                        },
                        imageSource: "/assets/images/and.png",
                        styles: {
                          padding: "0",
                          "max-width": "50px"
                        }
                      }
                    },
                    { // WFL
                      "fieldType": "square-image",
                      "fieldId": "fckzg75",
                      "properties": {
                        "grid": {
                          "columns": 4
                        },
                        imageSource: "/assets/images/wfl.svg",
                        styles: {
                          padding: "0",
                          "max-width": "240px"
                        }
                      }
                    }
                  ]
                }
              },
              { // Text
                "fieldId": "6g23fh65",
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 8,
                    "alignItems": "center",
                    "justifyContent": "center",
                    "marginTop": "50px",
                    paddingLeft: "0",
                    marginBottom: "150px"
                  },
                  "fields": [
                    { // Heading
                      "fieldType": "paragraph",
                      "fieldId": "fckzg75",
                      "properties": {
                        "grid": {
                          "columns": 12,
                          marginTop: "40px",
                          marginBottom: "50px"
                        },
                        text: "Thank You!",
                        "className": "heading text-center"
                      }
                    },
                    { // Subheading
                      "fieldType": "paragraph",
                      "fieldId": "34fs667wef",
                      "properties": {
                        "text": `Thank you for registering to the Wings for Life World Run.
                        <br>
                        <br>
                        <span style="font-weight: bold;">Your data have been successfully sent to us and will now be verified.</span>
                        <br>
                        <br>
                        As soon as we have verified your purchase and data, you will either receive a confirmation email, or an email with further questions (if your data was incomplete or was not correct). This can take up to 36 hours, we ask for your patience.
                        `,
                        "grid": {
                          "columns": 12
                        },
                        "className": "subHeading text-left"
                      }
                    }
                  ]
                }
              }
            ]
          }
        ]
      },
      { // ::PAGE Contact
        "pageName": "contact",
        isPublic: true,
        "pageId": 1119,
        "sections": [
          { // Heading
            "sectionId": "p43ogfp23",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "fields": [
              {
                "fieldId": "6g23fh65",
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 12,
                    "alignItems": "center",
                    "justifyContent": "space-between",
                    "marginTop": "50px",
                    padding: "0"
                  },
                  styles: {
                    background: "#FFFFFF",
                    "box-shadow": "0px 15px 15px rgba(0, 0, 0, 0.07)",
                    "border-radius": "30px"
                  },
                  "fields": [
                    { // Image
                      "fieldType": "square-image",
                      "fieldId": "fckzg75",
                      "properties": {
                        "grid": {
                          "columns": 6
                        },
                        imageSource: "/assets/images/contact.png",
                        classes: 'top-image',
                        styles: {
                          padding: "0"
                        }
                      }
                    },
                    { // Timer
                      "fieldType": "empty-bucket",
                      "fieldId": "emp123154",
                      "properties": {
                        "grid": {
                          columns: 6,
                          justifyContent: "center",
                          alignItems: "center"
                        },
                        fields: [
                          { // Timer
                            "fieldType": "countdown-timer",
                            "fieldId": "con1231",
                            "properties": {
                              "grid": {
                                "columns": 10,
                                marginTop: "44px",
                                marginBottom: "44px"
                              },
                              // This is GMT/UTC time
                              deadline: '08 May 2023 11:00:00 GMT',
                              image: {
                                src: '/assets/images/wfl.svg',
                                alt: 'World For Run',
                                maxWidth: '250px',
                                maxMobWidth: '130px'
                              },
                              styles: {
                                "flex-direction": "column",
                                "flex-wrap": "nowrap",
                                "row-gap": "20px"
                              }
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              },
              { // Text
                "fieldId": "6g23fh65",
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 8,
                    "alignItems": "center",
                    "justifyContent": "center",
                    "marginTop": "50px",
                    paddingLeft: "0",
                    marginBottom: "150px"
                  },
                  "fields": [
                    { // Heading
                      "fieldType": "paragraph",
                      "fieldId": "fckzg75",
                      "properties": {
                        "grid": {
                          "columns": 12,
                          marginTop: "40px",
                          marginBottom: "50px"
                        },
                        text: "Contact us",
                        "className": "heading text-center"
                      }
                    },
                    { // Subheading
                      "fieldType": "paragraph",
                      "fieldId": "34fs667wef",
                      "properties": {
                        "text": `If you have any questions, please feel free to get in touch via this email:
                        <br>
                        <a style="color: #4A3260; font-weight: 600;" href="mailto:wings.forlife@tpv-tech.com">wings.forlife@tpv-tech.com</a>
                        `,
                        "grid": {
                          "columns": 12
                        },
                        "className": "subHeading text-center"
                      }
                    }
                  ]
                }
              }
            ]
          }
        ]
      },
      { // ::PAGE About
        "pageName": "about",
        isPublic: true,
        "pageId": 1112,
        "sections": [
          { // Heading
            "sectionId": "p43ogfp23",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "fields": [
              {
                "fieldId": "6g23fh65",
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 12,
                    "alignItems": "center",
                    "justifyContent": "center",
                    "marginTop": "50px",
                    padding: "90px",
                    columnGap: "130px",
                    rowGap: "45px"
                  },
                  styles: {
                    background: "#FFFFFF",
                    "box-shadow": "0px 15px 15px rgba(0, 0, 0, 0.07)",
                    "border-radius": "30px"
                  },
                  "fields": [
                    { // Image
                      "fieldType": "square-image",
                      "fieldId": "fckzg75",
                      "properties": {
                        "grid": {
                          "columns": 4
                        },
                        imageSource: "/assets/images/tpvision.png",
                        styles: {
                          padding: "0",
                          "max-width": "300px"
                        }
                      }
                    },
                    { // &
                      "fieldType": "square-image",
                      "fieldId": "fckzg75",
                      "properties": {
                        "grid": {
                          "columns": 4
                        },
                        imageSource: "/assets/images/and.png",
                        styles: {
                          padding: "0",
                          "max-width": "50px"
                        }
                      }
                    },
                    { // WFL
                      "fieldType": "square-image",
                      "fieldId": "fckzg75",
                      "properties": {
                        "grid": {
                          "columns": 4
                        },
                        imageSource: "/assets/images/wfl.svg",
                        styles: {
                          padding: "0",
                          "max-width": "240px"
                        }
                      }
                    }
                  ]
                }
              },
              { // Text
                "fieldId": "6g23fh65",
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 8,
                    "alignItems": "center",
                    "justifyContent": "center",
                    "marginTop": "50px",
                    paddingLeft: "0",
                    marginBottom: "50px"
                  },
                  "fields": [
                    { // Heading
                      "fieldType": "paragraph",
                      "fieldId": "fckzg75",
                      "properties": {
                        "grid": {
                          "columns": 12,
                          marginTop: "40px",
                          marginBottom: "50px"
                        },
                        text: "About the Partnership",
                        "className": "heading text-center"
                      }
                    },
                    { // Subheading
                      "fieldType": "paragraph",
                      "fieldId": "34fs667wef",
                      "properties": {
                        "text": `
                        <p>Apart from growing the fruitful business in TV &amp; Sound, TP Vision has the ambition to further drive social impact and become “agents of change” towards general public, the media, partners and employees.<br />In recent years, we have built partnerships and projects that position us as a responsible and caring company. Partnering with the Wings for Life World Run is a key next step in our social impact journey. We believe this partnership encompasses a perfect mix of social awareness and positive investment. Both TP Vision and the Wings for Life World Run share the common goal of encouraging a healthier life for all at all ages.<br />The Wings for Life World Run and TP Vision – through its Philips Sports Headphones – will jointly create a relevant platform available to all.</p>
                        `,
                        "grid": {
                          "columns": 12
                        },
                        "className": "subHeading text-left"
                      }
                    },
                    {
                      fieldType: "video-comp",
                      fieldId: "key1243",
                      properties: {
                        grid: {
                          columns: 12,
                          marginTop: "10px",
                          marginBottom: "30px"
                        },
                        videoUrl: "https://jolt-assets.s3.eu-central-1.amazonaws.com/template/redbull/wingsforlife/about-2.mp4",
                        width: "700px",
                        mobileWidth: "100%",
                        styles: {
                          "border-radius": "39.0938px"
                        }
                      }
                    },
                    { // Subheading
                      "fieldType": "paragraph",
                      "fieldId": "34fs667w41241qef",
                      "properties": {
                        "text": `
                        <p>For TP Vision: <br />In order to generate trust, making a real difference is critical. Consumers, employees, the media increasingly decide who to work with and buy from based on genuine ethical and environmental practices. Therefore, it is important to start building public image campaigns where we demonstrate our efforts in generating a positive social impact. Having a clear messaging and campaign execution will make a strong business case for TP Vision as a responsible company. <br /><br />The core of this collaboration is to create awareness for our Philips Sports Headphones and to generate funds for Wings for Life research projects. All around the bigger cause: finding a cure for spinal cord injury.</p>
                        `,
                        "grid": {
                          "columns": 12
                        },
                        "className": "subHeading text-left"
                      }
                    },
                    { // Subheading
                      "fieldType": "paragraph",
                      "fieldId": "qw123333",
                      "properties": {
                        "text": `
                        <p>Commenting on the new partnership, Kostas Vouzas CEO TP Vision (Philips TV &amp; Sound) Europe and Americas said: ‘With our sports headphones, we want to bring joy to the everyday athlete. Encouraging the better enjoyment of sport for everybody has become one of our key objectives. We also realize that not everybody is able to sport. This is why we are delighted to support the Wings for Life World Run with who we can help to support the bigger cause: finding a cure for spinal cord injury’.<br /><br />Not very often a partnership can generate impact on three levels and has global coverage: <br />-    Research institutions will benefit from increased public awareness and extra funds to find a cure for spinal cord injury. <br />-    Consumers will be able to participate in the Wings for Life World Run by purchasing one of our Philips Sports Headphones<br />-    TP Vision employees will be able to join the race as a global team <br />About the Wings for Life World Run:<br />Since 2014, hundreds of thousands of people globally have run for those who can’t in the Wings for Life World Run. And they have been doing good at the same time, because 100% of all entry fees goes to the not-for-profit foundation Wings for Life, which supports promising research projects and clinical studies worldwide with the goal of finding a cure for spinal cord injury. The event’s format is part of the fun: All runners and wheelchair users start at exactly the same time, 11:00 UTC. Thirty minutes later, the Catcher Car – a moving finish line – begins pursuit, and once passed, a participant’s race is done. With a Virtual Catcher Car, the Wings for Life World Run App even makes it possible for participants to set their own course wherever they are. Everyone is a finisher, and everyone is connected to feel the joy and excitement of a truly global event.</p>
                        `,
                        "grid": {
                          "columns": 12
                        },
                        "className": "subHeading text-left"
                      }
                    },
                    {
                      fieldType: "video-comp",
                      fieldId: "key12233",
                      properties: {
                        grid: {
                          columns: 12,
                          marginTop: "10px",
                          marginBottom: "50px"
                        },
                        videoUrl: "https://jolt-assets.s3.eu-central-1.amazonaws.com/template/redbull/wingsforlife/about-2.mp4",
                        width: "700px",
                        mobileWidth: "100%",
                        styles: {
                          "border-radius": "39.0938px"
                        }
                      }
                    },
                    { // Subheading
                      "fieldType": "paragraph",
                      "fieldId": "qw12333314",
                      "properties": {
                        "text": `
                        <p>Colin Jackson, International Sports Director, Wings for Life World Run and Olympic Medalist said: ‘We always want people to have an amazing time – we want them to enjoy and feel that they are part of a global movement. With the App, your experience will be identical to the Flagship Runs. Either way, you will have a Catcher Car chasing you, and that is what makes it exciting – your experience is just phenomenal.’<br /><br />The Wings for Life World Run partnership with TP Vision – Philips Sports Headphones – is a natural one. Today, health and technology are closely linked. Philips Sports Headphones will enhance the unique Audio Experience as thousands of people come together to take part in a global sports event coordinated through the Wings for Life World Run App. Join us!</p>
                        `,
                        "grid": {
                          "columns": 12
                        },
                        "className": "subHeading text-left"
                      }
                    },
                  ]
                }
              }
            ]
          }
        ]
      },
      { // ::PAGE 404
        "pageName": "404",
        isPublic: true,
        "pageId": 1113,
        "sections": [
          { // Heading
            "sectionId": "p43ogfp23",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "fields": [
              {
                "fieldId": "6g23fh65",
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 12,
                    "alignItems": "center",
                    "justifyContent": "space-between",
                    "marginTop": "50px",
                    padding: "0"
                  },
                  styles: {
                    background: "#FFFFFF",
                    "box-shadow": "0px 15px 15px rgba(0, 0, 0, 0.07)",
                    "border-radius": "30px"
                  },
                  "fields": [
                    { // Image
                      "fieldType": "square-image",
                      "fieldId": "fckzg75",
                      "properties": {
                        "grid": {
                          "columns": 6
                        },
                        imageSource: "/assets/images/404.png",
                        classes: 'top-image',
                        styles: {
                          padding: "0"
                        }
                      }
                    },
                    { // 404 Image
                      "fieldType": "paragraph",
                      "fieldId": "fckzg75",
                      "properties": {
                        "grid": {
                          "columns": 6
                        },
                        text: "404",
                        styles: {
                          padding: "0",
                          "font-size": "139px",
                          "line-height": "170px",
                          "font-weight": "700",
                          "text-align": "center",
                          "color": "#9E5D26"
                        }
                      }
                    }
                  ]
                }
              },
              { // Text
                "fieldId": "6g23fh65",
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 8,
                    "alignItems": "center",
                    "justifyContent": "center",
                    "marginTop": "50px",
                    paddingLeft: "0",
                    marginBottom: "150px"
                  },
                  "fields": [
                    { // Heading
                      "fieldType": "paragraph",
                      "fieldId": "fckzg75",
                      "properties": {
                        "grid": {
                          "columns": 12,
                          marginTop: "40px",
                          marginBottom: "50px"
                        },
                        text: "Oops, This Page Could Not Be Found!",
                        "className": "heading text-center"
                      }
                    },
                    { // Subheading
                      "fieldType": "paragraph",
                      "fieldId": "34fs667wef",
                      "properties": {
                        "text": `
                        Can't find what you need?
                        `,
                        "grid": {
                          "columns": 12,
                          marginBottom: "50px"
                        },
                        "className": "subHeading text-center"
                      }
                    },
                    {
                      fieldType: "button-component",
                      fieldId: "but123d",
                      properties: {
                        grid: {
                          columns: 6,
                          marginBottom: "50px"
                        },
                        text: 'Go back to homepage',
                        addClass: 'btn-back',
                        action: {
                          'anchor': true,
                          'link': '/'
                        }
                      }
                    }
                  ]
                }
              }
            ]
          }
        ]
      },
      { // ::PAGE Campaign is over
        "pageName": "campaign-is-over",
        isPublic: true,
        "pageId": 1114,
        "sections": [
          { // Heading
            "sectionId": "p43ogfp23",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "fields": [
              {
                "fieldId": "6g23fh65",
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 12,
                    "alignItems": "center",
                    "justifyContent": "space-between",
                    "marginTop": "50px",
                    padding: "0"
                  },
                  styles: {
                    background: "#FFFFFF",
                    "box-shadow": "0px 15px 15px rgba(0, 0, 0, 0.07)",
                    "border-radius": "30px"
                  },
                  "fields": [
                    { // Image
                      "fieldType": "square-image",
                      "fieldId": "fckzg75",
                      "properties": {
                        "grid": {
                          "columns": 12
                        },
                        imageSource: "/assets/images/over.png",
                        styles: {
                          padding: "0"
                        }
                      }
                    }
                  ]
                }
              },
              { // Text
                "fieldId": "6g23fh65",
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 8,
                    "alignItems": "center",
                    "justifyContent": "center",
                    "marginTop": "50px",
                    paddingLeft: "0",
                    marginBottom: "150px"
                  },
                  "fields": [
                    { // Heading
                      "fieldType": "paragraph",
                      "fieldId": "fckzg75",
                      "properties": {
                        "grid": {
                          "columns": 12,
                          marginTop: "40px",
                          marginBottom: "50px"
                        },
                        text: "The Campaign is Over",
                        "className": "heading text-center"
                      }
                    },
                    { // Subheading
                      "fieldType": "paragraph",
                      "fieldId": "34fs667wef",
                      "properties": {
                        "text": `
                        Check our homepage for any active Wings for Life World Run campaigns
                        `,
                        "grid": {
                          "columns": 12,
                          marginBottom: "50px"
                        },
                        "className": "subHeading text-center"
                      }
                    },
                    {
                      fieldType: "button-component",
                      fieldId: "but123d",
                      properties: {
                        grid: {
                          columns: 6,
                          marginBottom: "50px"
                        },
                        text: 'Go back to homepage',
                        addClass: 'btn-back',
                        action: {
                          'anchor': true,
                          'link': '/'
                        }
                      }
                    }
                  ]
                }
              }
            ]
          }
        ]
      }
    ],
    "header": {
      "fieldType": "navbar",
      "fieldId": "cbx34t",
      "properties": {
        "grid": {
          "columns": 12,
          "paddingTop": "24px",
          "paddingBottom": "24px"
        },
        "backgroundColor": "linear-gradient(90.18deg, #9E5D26 0%, #412316 28.12%, #2F3341 63.54%, #373D56 100%)",
        "title": "",
        "color": "#FFFFFF",
        "logo": {
          "imageSource": "/assets/images/tpvisionLogo.png",
          "alternateText": "TP Vision",
          width: "200px",
          title: ""
        },
        "favicon": {
          "imageSource": "/assets/images/favicon.png"
        },
        "fields": [
          { // TP Vision Employee
            "fieldId": "g4kgmd",
            "fieldType": "anchor",
            "properties": {
              "text": "Employee",
              action: {
                "fn": "goToPage",
                "params": "employee-page"
              }
            }
          },
          { // Partner
            "fieldId": "g4kgmsb",
            "fieldType": "anchor",
            "properties": {
              "text": "Partner",
              action: {
                "fn": "goToPage",
                "params": "partner-page"
              }
            }
          },
          { // About
            "fieldId": "g4kgmas",
            "fieldType": "anchor",
            "properties": {
              "text": "About",
              action: {
                "fn": "goToPage",
                "params": "about"
              }
            }
          },
          { // Contact
            "fieldId": "g4kgm42",
            "fieldType": "anchor",
            "properties": {
              "text": "Contact",
              action: {
                "fn": "goToPage",
                "params": "contact"
              }
            }
          }
        ],
        "showLine": false,
        "meta": [
          { "name": "Philips World Run", "content": "Philips World Run - TP Vision" }
        ]
      }
    },
    "footer": {
      "fieldType": "footer-component",
      "fieldId": "4tfbzz",
      "properties": {
        logo: {
          src: "/assets/images/tpvisionLogo.png",
          url: "https://www.tpvision.com/",
          styles: {
            "max-width": "240px"
          }
        },
        "grid": {
          "alignItems": "center",
          "justifyContent": "center",
          "columns": "12"
        },
        "background": "linear-gradient(360deg, #9E5D26 -81.79%, #4A3260 120.56%)",
        color: "#FFFFFF",
        topBlock: {
          status: false
        },
        "columnList": [
          {
            "fields": [
              { // Contact
                "fieldType": "anchor",
                "fieldId": "6mo8qp",
                "properties": {
                  "text": "Contact",
                  "url": "mailto:wings.forlife@tpv-tech.com",
                  "target": "_blank"
                }
              },
              { // TPVISION
                "fieldType": "anchor",
                "fieldId": "6mo8qp",
                "properties": {
                  "text": "TPVISION",
                  "url": "https://www.tpvision.com/",
                  "target": "_blank"
                }
              },
              { // Cookie Notice
                "fieldType": "anchor",
                "fieldId": "6mo8qp",
                "properties": {
                  "text": "Cookie Notice",
                  "url": "https://www.tpvision.com/privacy-policy/",
                  "target": "_blank"
                }
              },
              { // Privacy Notice
                "fieldType": "anchor",
                "fieldId": "6mo8qp",
                "properties": {
                  "text": "Privacy Notice",
                  "url": "https://www.tpvision.com/privacy-policy/",
                  "target": "_blank"
                }
              },
              { // Terms of Use
                "fieldType": "anchor",
                "fieldId": "6mo8qp",
                "properties": {
                  "text": "Terms of Use",
                  "url": "https://www.tpvision.com/terms-of-use/",
                  "target": "_blank"
                }
              }
            ]
          }
        ],
        copyright: {
          text: '© Copyright - TP Vision Europe B.V.',
          styles: {
            "font-size": "12px",
            "line-height": "14px"
          }
        }
      }
    },
    "errors": {
    },
    "dictionary": {
      "en": {
        "messages": {
          "password": "Password must have at least 8 charachters and must contain letters and numbers.",
          "plz": "PLZ darf maximal 4 oder 5 Stellen haben",
          "iban": "Bitte geben Sie einen gültigen IBAN ein",
          "bic": "Bitte geben Sie einen gültigen BIC ein",
          "phonePrefix": "Ländervorwahl ist ein Pflichtfeld",
          "confirmed": "Password does not match"
        }
      }
    },
    "campaignId": "rb-employees-relaunch",
    "url": "https://js-backend.justsnap.eu/api/",
    "name": "rb-employees-relaunch"
  },
  componentStatus: {},
  modal: {
    type: 'error',
    message: 'An error occured.',
    isActive: false
  },
  campaignEndDate: "2023-06-04",
  customerToken: '',
  receiptToken: '',
  campaignId: 'rb-employees-relaunch',
  // selectedQuantity: [],
  modelNumber: '',
  serial: '',
  purchaseDate: '',
  formData: new FormData(),
  referenceNumber: '',
  hostCountry: '',
  uploadPercentage: '',
  signedUp: false,
  userType: ''
}
